import defs from './_core/defs.js';
import selectNodes, { scopeToSandbox } from './bindnode/_selectnodes.js';
import checkObjectType from './_helpers/checkobjecttype.js';
var customSelectorTestReg = /:sandbox|:bound\(([^(]*)\)/;
export default function select(object, selector) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    selector = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'select');
  }
  // the selector includes "custom" things like :sandbox or :bound(KEY)
  if (customSelectorTestReg.test(selector)) {
    return selectNodes(object, scopeToSandbox(selector))[0] || null;
  }
  var def = defs.get(object);
  if (!def || typeof selector !== 'string') {
    return null;
  }
  var propDef = def.props.sandbox;
  if (!propDef) {
    return null;
  }
  var bindings = propDef.bindings;
  if (bindings) {
    // iterate over all bound nodes trying to find a descendant matched given selector
    for (var i = 0; i < bindings.length; i++) {
      var node = bindings[i].node;
      var selected = node.querySelector(selector);
      if (selected) {
        return selected;
      }
    }
  }
  return null;
}